import cn from 'classnames';
import { VhcItem } from 'features/vhc/model';
import { useVhcStore } from 'features/vhc/model/vhc-store';
import { Form } from 'react-bootstrap';
import { Controller, useFormContext } from 'react-hook-form';

export const VhcRecordDescription = () => {
  const { watch, control } = useFormContext<VhcItem>();
  const totalName = watch('description') ?? '';

  const { recordModalData } = useVhcStore();
  const { isReport, isComplete } = recordModalData || {};

  return (
    <Form.Group className="mb-3">
      <Form.Label className="d-block d-lg-none fs-7 mb-2">Description</Form.Label>

      <div className="row align-items-center">
        <Form.Label className="col-lg-3 d-none d-lg-block fs-7 m-0">Description</Form.Label>

        <div className="col-12 col-lg-9">
          <Controller
            rules={{ required: true }}
            name="description"
            control={control}
            render={({ field }) => (
              <Form.Control
                disabled={isReport || isComplete}
                className={cn('w-100 form-control-solid', !field.value ? 'is-invalid' : '')}
                {...field}
                value={field.value ?? totalName}
              />
            )}
          />
        </div>
      </div>
    </Form.Group>
  );
};
